{
  "event": {
    "title": "Painel de aprovação"
  },

  "workflow": {
    "defaultGroup": "emaprovacao",
    "transitions": {
      "emaprovacao": ["aprovados", "naoaprovados"],
      "aprovados": ["naoaprovados"],
      "naoaprovados": ["aprovados"]
    },
    "bulkApprove": {
      "enabled": true,
      "fromGroup": "emaprovacao",
      "toGroup": "aprovados",
      "scope": "page"
    }
  },

  "pastLabels": {
    "emaprovacao": "devolvida para análise",
    "aprovados": "aprovada",
    "naoaprovados": "não aprovada"
  },

  "listing": {
    "pageSize": 100,
    "maxPageSize": 200
  }
}
